import React from 'react';
import textile from 'textile-js';

// Wrapper to do textile parsing on a component
export default function Textile({text}){
  const mText = React.useMemo(() => textile(text),[text]);
  return <div style={{whiteSpace: 'pre-line'}} dangerouslySetInnerHTML={{__html: mText}}></div>
}
